import clsx from 'clsx';

import { Button } from '~/shared/components/Button/Button';
import Link from '~/shared/components/Link/Link';

import styles from '../M20Categories.module.css';

type CategoryCardProps = {
	link: string;
	name: string;
	selected: boolean;
};

export const CategoryCard = ({ link, name, selected }: CategoryCardProps) => {
	const variant = selected ? 'filled' : 'outline';

	return (
		<Link
			href={link}
			isCustomStyle={true}
		>
			<Button
				variant={variant}
				className={clsx(styles.linkButton, selected ? styles.linkButtonFilled : styles.linkButtonOutline)}
			>
				{name}
			</Button>
		</Link>
	);
};
